import React from 'react';

import styles from './styles.module.scss';
import {Block, Radar, User, Center, Radar2} from '../../../assets/icons/antiNuke';

export const AntiNukeFeature = ({second}) => {
  return (
    <div className={styles.wrapper}>
      <Block />
      <div className={styles.radar}>{second ? <Radar /> : <Radar2 />}</div>
      <div className={styles.user1}>
        <User />
      </div>
      <div className={styles.user2}>
        <User />
      </div>
      <div className={styles.user3}>
        <User />
      </div>

      <div className={styles.center}>
        <Center />
      </div>
    </div>
  );
};
